/**
 * Graylog logging utility for debugging purposes.
 * Sends log messages to a Graylog endpoint for remote monitoring.
 */

type GraylogPayload = {
    contextName: string;
    timestamp: string;
    message: string;
    userAgent: string;
};

/**
 * Sends JavaScript context data to a Graylog endpoint.
 * Uses no-cors mode to avoid CORS issues.
 * 
 * @param contextName - The context or category of the log message
 * @param message - The message or data to log
 */
export async function logContext(contextName: string, message: string): Promise<void> {
    const contextData: GraylogPayload = {
        contextName: contextName,
        timestamp: new Date().toISOString(),
        message: message,
        userAgent: navigator.userAgent
    };

    try {
        await fetch(`https://www.drillisch-online.de/csp-reports?${contextName}=${encodeURIComponent(message)}`, {
            method: 'POST',
            mode: 'no-cors',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(contextData)
        });
    } catch (error) {
        // Silently fail - don't let logging errors break the application
        // In development, you might want to log to console:
        // console.error('Graylog logging failed:', error);
    }
}
